import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for SongUpload; each part uses its own slice of it */
import styles from './SongUpload.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SongUploadChoiceProps {
  name: string;
  value: string;
  checked: boolean;
  title: string;
  hint: string;
  onSelect: () => void;
}

/** One option card of the dialog (design c3 `.opt`): a radio, a bold line and a hint. */
const SongUploadChoiceComponent: React.FC<SongUploadChoiceProps> = ({
  name,
  value,
  checked,
  title,
  hint,
  onSelect,
}) => (
  <label className={clsx(styles.option, checked && styles.optionOn)} htmlFor={`${name}-${value}`}>
    <input
      id={`${name}-${value}`}
      type="radio"
      className="form-check-input"
      name={name}
      value={value}
      checked={checked}
      onChange={onSelect}
    />
    <span>
      <b>{title}</b>
      <small>{withBrandWord(hint)}</small>
    </span>
  </label>
);

export const SongUploadChoice = TypedMemo(SongUploadChoiceComponent);
